var sohubs = {
    sm_url: "https://socialmanage.io/js/social-manage.min.js",
    sm_instance: null,
    id:74,
    hasInit: false,
    init: function() {
        var _this = this;
        var existing_script = document.querySelector('script[src="' + _this.sm_url + '"]');
        var sm_script = function() {
            if ( _this.sm_instance ) { 
                return; 
            }
            // _this.sm_instance = window.social_manage("#social-hub-"+_this.id+"", "https://social.manage.com.au/stream/"+_this.id+"/default", _this.id);
            _this.sm_instance = window.social_manage("#social-hub-"+_this.id+"", "https://socialmanage.io/stream/"+_this.id+"/default", _this.id);
            _this.hasInit = true;
        };

        if (!existing_script) {
            var script     = document.createElement('script');
            script.src = _this.sm_url;
            // callback function once script loaded
            script.onload = sm_script;

            // append script at end of body
            document.body.appendChild(script);
        }  else {
            sm_script();
        }
    },
    destroy: function() {
        var _this = this;
        if ( !_this.hasInit ) { return; }
        // if (!hasInit) { return; }
        if ( _this.sm_instance ) {
            _this.sm_instance.destroy();
        }
        _this.sm_instance = null;
    }
}